// extracted by mini-css-extract-plugin
export default {"button":"Ko-z","reviewSort":"Lo-z"};